import { render, staticRenderFns } from "./SocietySection.vue?vue&type=template&id=2abc3968"
import script from "./SocietySection.vue?vue&type=script&lang=js"
export * from "./SocietySection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports